var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _summaryThreshold, _CartDrawerComponent_instances, themeDrawer_get, dialog_get, _handleDrawerOpen, _handleCartLinesUpdate, isCartEmpty_fn, updateStickyState_fn;
import { Component } from "@theme/component";
import { StandardEvents } from "@shopify/events";
import { DrawerOpenEvent } from "@theme/theme-drawer";
class CartDrawerComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartDrawerComponent_instances);
    this.restoreFrame = 0;
    this.handleCartSectionRestored = () => {
      cancelAnimationFrame(this.restoreFrame);
      this.restoreFrame = requestAnimationFrame(() => {
        this.restoreFrame = 0;
        if (this.isConnected) __privateMethod(this, _CartDrawerComponent_instances, updateStickyState_fn).call(this);
      });
    };
    /** @type {number} */
    __privateAdd(this, _summaryThreshold, 0.5);
    /**
     * Handles the theme-drawer opening — updates sticky state and wires up the installments CTA.
     */
    __privateAdd(this, _handleDrawerOpen, () => {
      __privateMethod(this, _CartDrawerComponent_instances, updateStickyState_fn).call(this);
      customElements.whenDefined("shopify-payment-terms").then(() => {
        var _a, _b;
        const cta = (_b = (_a = this.querySelector("shopify-payment-terms")) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector("#shopify-installments-cta");
        cta == null ? void 0 : cta.addEventListener("click", () => {
          var _a2;
          return (_a2 = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _a2.close();
        }, { once: true });
      });
    });
    /**
     * @param {import('@shopify/events').CartLinesUpdateEvent} event
     */
    __privateAdd(this, _handleCartLinesUpdate, (event) => {
      var _a, _b, _c;
      const shouldAutoOpen = this.hasAttribute("auto-open") && event.action === "add" && !((_a = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _a.isOpen);
      const sourceModal = (
        /** @type {HTMLDialogElement | null} */
        event.target instanceof Element ? event.target.closest("dialog:modal") : null
      );
      if (shouldAutoOpen && !sourceModal && !__privateMethod(this, _CartDrawerComponent_instances, isCartEmpty_fn).call(this)) {
        (_b = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _b.open();
      }
      (_c = event.promise) == null ? void 0 : _c.then(({ detail }) => {
        const settle = () => requestAnimationFrame(() => __privateMethod(this, _CartDrawerComponent_instances, updateStickyState_fn).call(this));
        if (!shouldAutoOpen || (detail == null ? void 0 : detail.didError)) {
          settle();
          return;
        }
        const openAndSettle = () => {
          var _a2, _b2;
          if (!((_a2 = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _a2.isOpen)) (_b2 = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _b2.open();
          settle();
        };
        if (sourceModal == null ? void 0 : sourceModal.open) {
          sourceModal.addEventListener("close", openAndSettle, { once: true });
        } else {
          openAndSettle();
        }
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[cart-drawer] Event promise rejected:", error);
      });
    });
  }
  connectedCallback() {
    var _a, _b;
    super.connectedCallback();
    this.addEventListener("cart-section:restored", this.handleCartSectionRestored);
    document.addEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _handleCartLinesUpdate));
    (_a = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _a.addEventListener(DrawerOpenEvent.eventName, __privateGet(this, _handleDrawerOpen));
    if ((_b = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _b.hasAttribute("open")) {
      __privateGet(this, _handleDrawerOpen).call(this);
    }
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    this.removeEventListener("cart-section:restored", this.handleCartSectionRestored);
    cancelAnimationFrame(this.restoreFrame);
    this.restoreFrame = 0;
    document.removeEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _handleCartLinesUpdate));
    (_a = __privateGet(this, _CartDrawerComponent_instances, themeDrawer_get)) == null ? void 0 : _a.removeEventListener(DrawerOpenEvent.eventName, __privateGet(this, _handleDrawerOpen));
  }
}
_summaryThreshold = new WeakMap();
_CartDrawerComponent_instances = new WeakSet();
themeDrawer_get = function() {
  return (
    /** @type {import('@theme/theme-drawer').ThemeDrawer | null} */
    this.closest("theme-drawer")
  );
};
dialog_get = function() {
  return this.closest("dialog");
};
_handleDrawerOpen = new WeakMap();
_handleCartLinesUpdate = new WeakMap();
isCartEmpty_fn = function() {
  return Boolean(this.querySelector(".cart-drawer--empty"));
};
updateStickyState_fn = function() {
  const dialog = __privateGet(this, _CartDrawerComponent_instances, dialog_get);
  if (!dialog) return;
  const content = dialog.querySelector(".cart-drawer__content");
  const summary = dialog.querySelector(".cart-drawer__summary");
  if (!content || !summary) {
    dialog.setAttribute("cart-summary-sticky", "false");
    return;
  }
  const drawerHeight = dialog.getBoundingClientRect().height;
  const summaryHeight = summary.getBoundingClientRect().height;
  const ratio = summaryHeight / drawerHeight;
  dialog.setAttribute("cart-summary-sticky", ratio > __privateGet(this, _summaryThreshold) ? "false" : "true");
};
if (!customElements.get("cart-drawer-component")) {
  customElements.define("cart-drawer-component", CartDrawerComponent);
}
